// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1XZeK","header":"ClearentDisclaimer_header__9nIUR","inner":"ClearentDisclaimer_inner__1G9o5"};